import { render, staticRenderFns } from "./ProductFlavors.vue?vue&type=template&id=4a954510&"
import script from "./ProductFlavors.vue?vue&type=script&lang=js&"
export * from "./ProductFlavors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports